module.exports = __webpack_public_path__ + "static/media/CartPencil.ea2090fb.webp";